import { cn } from "@/shared/lib/cn";

export type InvoiceNatureKey = "forfait_mensuel" | "hors_forfait";

export function resolveInvoiceNatureKey(input: {
  invoiceNature?: InvoiceNatureKey | string | null;
  isForfaitMensuel?: boolean | null;
}): InvoiceNatureKey {
  if (input.invoiceNature === "forfait_mensuel" || input.invoiceNature === "hors_forfait") {
    return input.invoiceNature;
  }
  return input.isForfaitMensuel ? "forfait_mensuel" : "hors_forfait";
}

export function invoiceNatureShortLabel(nature: InvoiceNatureKey): string {
  return nature === "forfait_mensuel" ? "Forfait mensuel" : "Hors forfait";
}

type InvoiceNatureBadgeProps = {
  nature?: InvoiceNatureKey | string | null;
  isForfaitMensuel?: boolean | null;
  className?: string;
};

export function InvoiceNatureBadge({
  nature,
  isForfaitMensuel,
  className,
}: InvoiceNatureBadgeProps) {
  const key = resolveInvoiceNatureKey({ invoiceNature: nature, isForfaitMensuel });
  const isForfait = key === "forfait_mensuel";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        isForfait ? "bg-teal-soft/80 text-teal" : "bg-purple-soft/80 text-purple",
        className,
      )}
    >
      {invoiceNatureShortLabel(key)}
    </span>
  );
}
